import { useQuery } from '@tanstack/react-query';
import { useIsAuth } from '@/entities/user/session/@x/access-rule';
import { useRulesQueryConfig } from './user-rules-query';

export const useUserRules = () => {
  const isAuth = useIsAuth();

  return useQuery({ ...useRulesQueryConfig, enabled: isAuth });
};